import { createCrudActions } from "../utils/crudGenerator";

const formatUbications = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.place}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchUbications,
  create: createUbication,
  update: updateUbication,
  delete: deleteUbications,
} = createCrudActions("UBICATION", "Ubicaciones", formatUbications);
